import React from "react";

export function useOnClickOutside(
  ref: React.MutableRefObject<HTMLDivElement | undefined | null>,
  cb: (e: MouseEvent) => void = () => null
) {
  const callbackRef = React.useRef<typeof cb>();
  callbackRef.current = cb;
  React.useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        ref.current &&
        !ref.current.contains(event.target as Node) &&
        callbackRef.current
      ) {
        callbackRef.current(event);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside, true);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside, true);
    };
  }, [ref, callbackRef]);
}
